import { mockEmployeeData } from "../constants/mockEmployeeData";
import { mockEmployeeAssets } from "../constants/mockEmployeeAssets";
import { mockLeaveRequests } from "../constants/mockLeaveRequests";
import { mockOnboardingData } from "../constants/mockOnboardingData";

function simulateFetch(data, delay = 500) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(structuredClone(data));
    }, delay);
  });
}

const mockDepartments = [...new Set(mockEmployeeData.map(emp => emp.department))]
  .map((name, index) => ({
    id: index + 1,
    name,
  }));

export const dashboardService = {
  getEmployees: () => simulateFetch(mockEmployeeData),

  getDepartments: () => simulateFetch(mockDepartments),

  getAssets: () => simulateFetch(mockEmployeeAssets),

  getLeaves: () => simulateFetch(mockLeaveRequests),

  getOnboarding: () => simulateFetch(mockOnboardingData),
};